module.exports = __webpack_public_path__ + "static/climatisation3-de1874b2d4253e1ac373deec8231991b.jpg";